import _ from 'lodash';
import { Tooltip } from 'react-tooltip';
import { NoData } from '@/app/components/no-data.tsx';
import { Paginator, usePagination } from '@/app/components/paginator.tsx';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  useSort,
} from '@/primitives/table.tsx';
import type { StaffMemberListModel } from '../../../types/staff-member.type';

const RepStaffMemberTable = ({
  data,
  tableClass = 'border rounded',
}: {
  data: StaffMemberListModel[];
  tableClass?: string;
}) => {
  const { sort, setSort, sortData } = useSort({
    data,
  });

  const pager = usePagination({ data: sortData, resourceName: 'staff members' });
  const { pagedData } = pager;

  return (
    <>
      <Table className={tableClass} currentSort={sort} setCurrentSort={setSort}>
        <TableHead>
          <TableRow>
            <TableHeader sortColumn='lastName'>Staff</TableHeader>
            <TableHeader sortColumn='position'>Position</TableHeader>
            <TableHeader sortColumn='staffMemberCategory.description'>Category</TableHeader>
            <TableHeader>Dietary Restrictions</TableHeader>
            <TableHeader>Dietary Preferences</TableHeader>
            <TableHeader>Public Notes</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {pagedData?.length > 0 ? (
            pagedData.map(value => (
              <TableRow key={value.id}>
                <TableCell>
                  {value.firstName} {value.lastName}
                </TableCell>
                <TableCell>
                  {_(value.accountSiteStaffMembers)
                    .map(x => x.position)
                    .uniq()
                    .join(', ')}
                </TableCell>
                <TableCell>
                  {_(value.accountSiteStaffMembers)
                    .map(x => x.staffMemberCategory?.description)
                    .filter(x => x?.length > 0)
                    ?.uniq()
                    .join(', ') ?? 'Other'}
                </TableCell>
                <TableCell id={`dietary-restrict-${value.id}`}>
                  {_.truncate(
                    value.dietaryRestrictions.concat([value.otherDietaryRestriction]).join(', '),
                    { length: 25 },
                  )}
                  <Tooltip
                    anchorSelect={`#dietary-restrict-${value.id}`}
                    content={value.dietaryRestrictions
                      .concat([value.otherDietaryRestriction])
                      .join(', ')}
                  />
                </TableCell>
                <TableCell id={`dietary-pref-${value.id}`}>
                  {_.truncate(
                    value.dietaryPreferences
                      .concat([value.otherDietaryPreference])
                      .filter(x => x)
                      .join(', '),
                    { length: 25 },
                  )}
                  <Tooltip
                    anchorSelect={`#dietary-pref-${value.id}`}
                    content={value.dietaryPreferences
                      .concat([value.otherDietaryPreference])
                      .filter(x => x)
                      .join(', ')}
                  />
                </TableCell>
                <TableCell className='text-wrap'>{value.foodNotes}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6}>
                <NoData />
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <Paginator {...pager} />
    </>
  );
};

export default RepStaffMemberTable;
